export const isExpired = (epochMilliSeconds: number) => Date.now() > epochMilliSeconds;

export const getExpiryTime = (seconds: number) =>
  Date.now() + seconds * 1000;